import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActionResultClass } from '../model/search-result';
import { catchError, map, tap, share } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { Observable, of } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

/**
 * Deal token to server (environment.APIBaseUrl)
 *
 * @publicApi
 */
export class AuthService {
  protected BaseUrl = environment.APIBaseUrl;
  // SiteUrl: string;
  StartGetting: boolean;
  isExpired: boolean;
  datePipe: DatePipe;

  constructor(private httpClient: HttpClient) {
    this.StartGetting = false;
    this.datePipe = new DatePipe('en-US');
  }

  public AuthenticateAAD(applicationId: string, redirectUri: string, errorRedirectUri: string, successCallback: IHttpCallBack, failCallback: IHttpCallBack = null) {
    const base64applicationId = btoa(applicationId);
    const base64RedirectUri = btoa(redirectUri);
    const base64ErrorRedirectUri = btoa(errorRedirectUri);
    const state = `${base64applicationId}:${base64RedirectUri}:${base64ErrorRedirectUri}`;
    const encodedState = encodeURIComponent(state);
    const apiUri = `${this.BaseUrl}${environment.AADAuthenticateUrl}${encodedState}`;
    console.log({
      applicationId,
      base64applicationId,
      redirectUri,
      base64RedirectUri,
      errorRedirectUri,
      base64ErrorRedirectUri,
      state,
      encodedState,
      apiUri
    });
    window.location.href = apiUri;
  }

  /**
   * To get SSO sessionID to auth server (environment.APIBaseUrl + 'Auth/SSOLogin')
   *
   * @param body  The object need inculde (ApplicationID, AuthCode, UserId, Password).
   * @param successCallback  When success to call server then call this fucntion.
   * @param failCallback  When fail to call server then call this fucntion.
   *
   */
  public GetSSOToken(body: any, successCallback: IHttpCallBack, failCallback: IHttpCallBack = null) {
    let LoginUrl = this.BaseUrl + 'Auth/PageLogin';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Auth': "Basic " + btoa(`${body.ApplicationID}:${body.AuthCode}:${body.UserId}:${body.Password}`)
      })
    };

    this.httpClient.post<ActionResultClass>(LoginUrl, null, httpOptions)
      .pipe(
        catchError(this.handleError<ActionResultClass>(`login error`))
      )
      .subscribe(res => {
        if (res && res.success) {
          successCallback(res);
        } else {
          let msg = res ? res.message : 'error';
          console.error('login had error:' + msg);
          if (failCallback) {
            failCallback(res);
          }
        }
      }, err => {
        console.error('login had error 2 :' + err);
      });
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  public handleError<T>(operation = 'operation', result?: T) {
    return (err: any): Observable<T> => {
      // this.logger.warn('DA9001', 'handle error');
      //this.ErrorJson = JSON.parse(err.error);
      // TODO: send the error to remote logging infrastructure
      console.error(err); // log to console instead
      if (!err.error) {
        // this.logger.error('DA9001', err);
      } else if (err.error.Status)
        return of(err.error as T);
      else {
        let newErr: any = { Message: err.message };
        return of(newErr as T);
      }
    };
  }
}

export interface IHttpCallBack {
  (data: any);
};
